import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "line-icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "2",
      y: "2",
      rx: "2",
      ry: "2"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "2",
      y: "14",
      rx: "2",
      ry: "2"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "14",
      y: "2",
      rx: "2",
      ry: "2"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "14",
      y: "14",
      rx: "2",
      ry: "2"
    }, null, -1)
  ])))
}
export default { render: render }